module.exports = __webpack_public_path__ + "static/media/close.1d834c48.svg";